<template>
  <router-view v-slot="{Component, route}">
    <keep-alive :include="cachedViews">
      <component
        :is="Component"
        :key="route.fullPath"
      />
    </keep-alive>
  </router-view>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useStore } from '@/store'

export default defineComponent({
  name: 'SpecialPaymentRequestPOIndex',
  setup() {
    const store = useStore()
    const cachedViews = computed(() => store.state.tagViews.cachedViews)
    return {
      cachedViews
    }
  }
})
</script>
